import { LaptopMinimalIcon, MoonIcon, SunIcon } from 'lucide-react';
import { useId } from 'react';

import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { useTheme } from '@/context/theme';

export function ThemeRadioGroup() {
  const { theme, setTheme } = useTheme();

  return (
    <RadioGroup className="max-w-92 grid-cols-3" value={theme} onValueChange={setTheme}>
      {/* System */}
      <ThemeRadioGroupItem value={'system'} title="Systemowy" icon={<LaptopMinimalIcon />} />

      {/* Light */}
      <ThemeRadioGroupItem value={'light'} title="Jasny" icon={<SunIcon />} />

      {/* Dark */}
      <ThemeRadioGroupItem value={'dark'} title="Ciemny" icon={<MoonIcon />} />
    </RadioGroup>
  );
}

/**
 * Props for ThemeRadioGroupItem.
 * @property {string} value - The value for the radio item.
 * @property {string} title - The display title for the radio item.
 * @property {React.ReactNode} icon - The icon to display for the radio item.
 */
interface ThemeRadioGroupItemProps {
  value: string;
  title: string;
  icon: React.ReactNode;
}

export function ThemeRadioGroupItem(themeRadioGroupItemProps: ThemeRadioGroupItemProps) {
  const { value, icon, title } = themeRadioGroupItemProps;
  const id = useId();

  return (
    <div className="border-border-primary has-data-[state=checked]:border-border-brand has-data-[state=checked]:bg-fill-brand/5 has-data-[state=checked]:text-text-brand focus-within:outlin-2 outline-focus-ring relative flex cursor-pointer flex-col items-center gap-3 rounded-md border px-3 py-2 text-center shadow-xs outline-0 transition-[color,box-shadow] outline-none [&>svg]:size-4">
      <RadioGroupItem id={`${id}-radio-group-item`} value={value} className="sr-only absolute" />
      {icon}
      <label htmlFor={`${id}-radio-group-item`} className="cursor-pointer text-xs leading-none font-medium after:absolute after:inset-0">
        {title}
      </label>
    </div>
  );
}
